export default "__VITE_ASSET__51e86ccd__"